import axios from "axios";
import { getToken } from "../utils/auth.util";
const host = window.location.hostname;

export const getHost = () => {
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL}/`;
  }
  switch (host) {
    case "localhost":
      return "http://localhost:8008/v1/";
    case "192.168.29.182":
      return "http://192.168.29.182/shk/api/v1/";
    case "https://imaginative-klepon-6b538d.netlify.app/":
      return "https://37ea-2405-201-200d-1c68-fcb6-e72a-ac84-1977.ngrok-free.app/v1/";
    case "app-chatbizz.dhibot.com":
      return "https://api-chatbizz.dhibot.com/v1/";
    default:
      return "https://api-chatbizz.dhibot.com/v1/";
  }
};

export const BaseURL = getHost();

// ─── Global 401 Interceptor ──────────────────────────────────────────────────
// Automatically logs the user out and redirects to login whenever any API
// call returns 401 Unauthorized (e.g. expired/invalid token after server restart)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Clear stale token and user from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Redirect to login page
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
// ─────────────────────────────────────────────────────────────────────────────

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const defaultHeaders = {
  isAuth: true,
  AdditionalParams: {},
  isJsonRequest: true,
  api_key: true,
};

const handleError = (error) => {
  if (
    error &&
    error.hasOwnProperty("response") &&
    error.response &&
    error.response.hasOwnProperty("data") &&
    error.response.data &&
    error.response.data.hasOwnProperty("error") &&
    error.response.data.error
  ) {
    return error.response.data.error;
  } else {
    return error;
  }
};

export const ApiPostNoAuth = (type, userData) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        BaseURL + type,
        userData,
        getHttpOptions({ ...defaultHeaders, isAuth: false })
      )
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiPutNoAuth = (type, userData) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        BaseURL + type,
        userData,
        getHttpOptions({ ...defaultHeaders, isAuth: false })
      )
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiGetNoAuth = (type) => {
  return new Promise((resolve, reject) => {
    axios
      .get(BaseURL + type, getHttpOptions({ ...defaultHeaders, isAuth: false }))
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiGet = (type, AdditionalHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .get(BaseURL + type, getHeaderData(AdditionalHeader))
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiGetNoPid = (type, AdditionalHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .get(BaseURL + type, getHeaderData(AdditionalHeader))
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiPost = (type, userData, AdditionalHeader) => {
  return new Promise((resolve, reject) => {
    let headers;
    if (userData instanceof FormData) {
      const options = { ...defaultHeaders, isJsonRequest: false };
      let baseHeaders = getHttpOptions(options);
      if (AdditionalHeader && AdditionalHeader.headers) {
        baseHeaders.headers = {
          ...baseHeaders.headers,
          ...AdditionalHeader.headers,
        };
      }
      headers = baseHeaders;
    } else {
      headers = getHeaderData(AdditionalHeader);
    }
    axios
      .post(BaseURL + type, userData, headers)
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiPut = (type, userData, AdditionalHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .put(BaseURL + type, userData, getHeaderData(AdditionalHeader))
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const ApiDelete = (type, AdditionalHeader) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(BaseURL + type, getHeaderData(AdditionalHeader))
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        reject(handleError(error));
      });
  });
};

export const getHttpOptions = (options = defaultHeaders) => {
  let headers = {};
  if (options.hasOwnProperty("isAuth") && options.isAuth) {
    if (getToken()) {
      headers["Authorization"] = "Bearer " + getToken();
    } else {
      headers["Authorization"] = "Bearer " + params.token;
    }
  }

  if (options.hasOwnProperty("api_key") && options.api_key) {
    headers["api_key"] = "6QSy49rUTH";
  }
  if (options.hasOwnProperty("isJsonRequest") && options.isJsonRequest) {
    headers["Content-Type"] = "application/json";
  }

  if (options.hasOwnProperty("AdditionalParams") && options.AdditionalParams) {
    headers = { ...headers, ...options.AdditionalParams };
  }

  headers["ngrok-skip-browser-warning"] = "true";

  return { headers };
};

export const getHeaderData = (AdditionalHeader) => {
  let header = {
    ...getHttpOptions(),
  };
  if (AdditionalHeader) {
    header.headers = {
      ...header.headers,
      ...AdditionalHeader.headers,
    };
  }

  return header;
};

export const formDataHeader = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const urlEncodedHeader = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
